import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducers";
import { reactReduxFirebase, getFirebase } from "react-redux-firebase";
import { reduxFirestore, getFirestore } from "redux-firestore";
import firebase from "config/fbConfig";

const rrConfig = {
  userProfile: "users",
  useFirestoreForProfile: true,
  attachAuthIsReady: true,
  enableLogging: false,
};

// store enhancers
const storeEnhancers = [];

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(
        thunkMiddleware.withExtraArgument({ getFirebase, getFirestore })
      ),
      reactReduxFirebase(firebase, rrConfig),
      reduxFirestore(firebase),
      ...storeEnhancers
    )
  );

  return store;
}
